module.exports = __webpack_public_path__ + "img/5cdb144ebeb4443184d5c65e33056f09.996dafe3.png";